import Button from "../../../shared/components/Button";
import QuoteFormWrapper from "../../../shared/components/quoteFormWrapper";

const ContactOptionCard = ({
  title,
  description,
  buttonLabel,
  icon,
  onClick,
  disabled = false,
}) => (
  <QuoteFormWrapper>
    <div className="tw-flex tw-flex-col tw-items-start tw-gap-3">
      <div className="tw-text-dis-deep-blue">{icon}</div>
      <h2 className="tw-m-0 tw-text-xl tw-font-bold tw-text-dis-navy">
        {title}
      </h2>
      <p className="tw-m-0 tw-text-base tw-leading-[1.5] tw-text-dis-text-2">
        {description}
      </p>
      <Button
        variant="main"
        size="small"
        disabled={disabled}
        onClick={onClick}
      >
        {buttonLabel}
      </Button>
    </div>
  </QuoteFormWrapper>
);

export default ContactOptionCard;
